import { isObject } from '@pulse/common';
import { Observable, Subject } from 'rxjs';
import { SettingsUsage } from '../models';

export class UsageTrackerService {
    private usage$ = new Subject<SettingsUsage>();

    usages(): Observable<any> {
        return this.usage$.asObservable();
    }

    trackUsage(tag: string, key: string, value: any): any {
        if (isObject(value)) {
            const usage = this.usage$;
            const handler = {
                get(target: any, prop: any) {
                    (function () {
                        if (Object.hasOwn(target, prop)) {
                            usage.next({ tag, key, value });
                        }
                    })();

                    return target[prop];
                },
            };

            return new Proxy(value, handler);
        } else {
            this.usage$.next({ tag, key, value });

            return value;
        }
    }
}
